module.exports = __webpack_public_path__ + "res/24-img_more_rtl.18ae96f049632ba745c6a187fc73de43.png";